
export const translationService = {
    getTranslation,
    getTranslatedData,
    getTranslationAtIndex,
    getTranslationAtIndexAndProperty
};

function getTranslation(translations, property) {
    const properties = property.split('.');

    let value = translations;

    if (translations) {
        for (const prop of properties) {
            if (value.hasOwnProperty(prop)) {
                value = value[prop];
            } else {
                value = '';
                break;
            }
        }
    }
    return value;
}

function getTranslationAtIndex(array, index) {
    let value = null;

    if (array && Array.isArray(array) && array.length > index) {
        value = array[index];
    }

    return value;
}

function getTranslationAtIndexAndProperty(translations, index, property) {
    let value = null;

    if (
        translations &&
        Array.isArray(translations) &&
        translations.length > index &&
        translations[index].hasOwnProperty(property)
    ) {
        value = translations[index][property];
    }

    return value;
}

function getTranslatedData(langCode, component = '') {

    let generalJson = {};
    let accessibilityJson = {};
    let dataJson = {};

    switch (langCode) {
        case 'HE':
            generalJson = require('./../transalations/general/general_HE.json');
            accessibilityJson = require('./../transalations/general/accessibility_HE.json');
            break;
        case 'EN':
            generalJson = require('./../transalations/general/general_EN.json');
            accessibilityJson = require('./../transalations/general/accessibility_EN.json');
            break;
        case 'AE':
            generalJson = require('./../transalations/general/general_AE.json');
            accessibilityJson = require('./../transalations/general/accessibility_AE.json');
            break;
        case 'RU':
            generalJson = require('./../transalations/general/general_RU.json');
            accessibilityJson = require('./../transalations/general/accessibility_RU.json');
            break;
        default:
            generalJson = require('./../transalations/general/general_HE.json');
            accessibilityJson = require('./../transalations/general/accessibility_HE.json')
            break;
    }

    switch (component) {
        // screens
        case 'settingsScreen':
            if (langCode === 'EN')
                dataJson = require('./../transalations/screens/settings/settingsScreen_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/screens/settings/settingsScreen_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/screens/settings/settingsScreen_RU.json')
            else
                dataJson = require('./../transalations/screens/settings/settingsScreen_HE.json')
            break;
        case 'myChargersScreen':
            if (langCode === 'EN')
                dataJson = require('./../transalations/screens/myChargers/myChargersScreen_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/screens/myChargers/myChargersScreen_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/screens/myChargers/myChargersScreen_RU.json')
            else
                dataJson = require('./../transalations/screens/myChargers/myChargersScreen_HE.json')
            break;
        case 'pamentsScreen':
            if (langCode === 'EN')
                dataJson = require('./../transalations/screens/payments/paymentsScreen_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/screens/payments/paymentsScreen_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/screens/payments/paymentsScreen_RU.json')
            else
                dataJson = require('./../transalations/screens/payments/paymentsScreen_HE.json')
            break;
        case 'billsScreen':
            if (langCode === 'EN')
                dataJson = require('./../transalations/screens/bills/billsScreen_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/screens/bills/billsScreen_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/screens/bills/billsScreen_RU.json')
            else
                dataJson = require('./../transalations/screens/bills/billsScreen_HE.json')
            break;
        case 'addUpdateChargerScreen':
            if (langCode === 'EN')
                dataJson = require('./../transalations/screens/addUpdateCharger/addUpdateChargerScreen_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/screens/addUpdateCharger/addUpdateChargerScreen_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/screens/addUpdateCharger/addUpdateChargerScreen_RU.json')
            else
                dataJson = require('./../transalations/screens/addUpdateCharger/addUpdateChargerScreen_HE.json')
            break;
        case 'profileScreen':
            if (langCode === 'EN')
                dataJson = require('./../transalations/screens/profile/profileScreen_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/screens/profile/profileScreen_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/screens/profile/profileScreen_RU.json')
            else
                dataJson = require('./../transalations/screens/profile/profileScreen_HE.json')
            break;
        case 'addUpdateGroupScreen':
            if (langCode === 'EN')
                dataJson = require('./../transalations/screens/groups/addUpdateGroupScreen_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/screens/groups/addUpdateGroupScreen_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/screens/groups/addUpdateGroupScreen_RU.json')
            else
                dataJson = require('./../transalations/screens/groups/addUpdateGroupScreen_HE.json')
            break;
        case 'updateBillingScreen':
            if (langCode === 'EN')
                dataJson = require('./../transalations/screens/bills/updateBillingScreen_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/screens/bills/updateBillingScreen_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/screens/bills/updateBillingScreen_RU.json')
            else
                dataJson = require('./../transalations/screens/bills/updateBillingScreen_HE.json')
            break;
        case 'chargingStrategyScreen':
            if (langCode === 'EN')
                dataJson = require('./../transalations/screens/chargingStrategy/chargingStrategyScreen_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/screens/chargingStrategy/chargingStrategyScreen_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/screens/chargingStrategy/chargingStrategyScreen_RU.json')
            else
                dataJson = require('./../transalations/screens/chargingStrategy/chargingStrategyScreen_HE.json')
            break;
        case 'auth':
            if (langCode === 'EN')
                dataJson = require('./../transalations/screens/auth/auth_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/screens/auth/auth_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/screens/auth/auth_RU.json')
            else
                dataJson = require('./../transalations/screens/auth/auth_HE.json')
            break;
        case 'cardScreens':
            if (langCode === 'EN')
                dataJson = require('./../transalations/screens/cards/addUpdateCard_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/screens/cards/addUpdateCard_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/screens/cards/addUpdateCard_RU.json')
            else
                dataJson = require('./../transalations/screens/cards/addUpdateCard_HE.json')
            break;
        case 'driversScreen':
            if (langCode === 'EN')
                dataJson = require('./../transalations/screens/drivers/driversScreen_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/screens/drivers/driversScreen_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/screens/drivers/driversScreen_RU.json')
            else
                dataJson = require('./../transalations/screens/drivers/driversScreen_HE.json');
            break;
        case 'accessibilityStatementScreen':
            if (langCode === 'EN')
                dataJson = require('./../transalations/screens/settings/accessibilityStatement/AccessibilityStatementScreen_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/screens/settings/accessibilityStatement/AccessibilityStatementScreen_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/screens/settings/accessibilityStatement/AccessibilityStatementScreen_RU.json')
            else
                dataJson = require('./../transalations/screens/settings/accessibilityStatement/AccessibilityStatementScreen_HE.json')
            break;
        case 'privacyPolicyScreen':
            if (langCode === 'EN')
                dataJson = require('./../transalations/screens/settings/PrivacyPolicyScreen_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/screens/settings/PrivacyPolicyScreen_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/screens/settings/PrivacyPolicyScreen_RU.json')
            else
                dataJson = require('./../transalations/screens/settings/PrivacyPolicyScreen_HE.json')
            break;
        case 'locationsScreen':
            if (langCode === 'EN')
                dataJson = require('./../transalations/screens/locations/locationScreen_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/screens/locations/locationScreen_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/screens/locations/locationScreen_RU.json')
            else
                dataJson = require('./../transalations/screens/locations/locationScreen_HE.json')
            break;

        // components
        case 'chargersCardsDriversTopButtons':
            if (langCode === 'EN')
                dataJson = require('./../transalations/components/chargersCardsDriversTopButtons/chargersCardsDriversTopButtonsComponent_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/components/chargersCardsDriversTopButtons/chargersCardsDriversTopButtonsComponent_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/components/chargersCardsDriversTopButtons/chargersCardsDriversTopButtonsComponent_RU.json')
            else
                dataJson = require('./../transalations/components/chargersCardsDriversTopButtons/chargersCardsDriversTopButtonsComponent_HE.json')
            break;
        case 'chargersListComponent':
            if (langCode === 'EN')
                dataJson = require('./../transalations/components/chargersListComponent/chargersListComponent_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/components/chargersListComponent/chargersListComponent_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/components/chargersListComponent/chargersListComponent_RU.json')
            else
                dataJson = require('./../transalations/components/chargersListComponent/chargersListComponent_HE.json')
            break;
        case 'userMenuComponent':
            if (langCode === 'EN')
                dataJson = require('./../transalations/components/userMenu/userMenuComponent_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/components/userMenu/userMenuComponent_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/components/userMenu/userMenuComponent_RU.json')
            else
                dataJson = require('./../transalations/components/userMenu/userMenuComponent_HE.json')
            break;
        case 'bottomNavigationComponent':
            if (langCode === 'EN')
                dataJson = require('./../transalations/components/bottomNavigationComponent/bottomNavigationComponent_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/components/bottomNavigationComponent/bottomNavigationComponent_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/components/bottomNavigationComponent/bottomNavigationComponent_RU.json')
            else
                dataJson = require('./../transalations/components/bottomNavigationComponent/bottomNavigationComponent_HE.json')
            break;
        case 'visualStepperComponent':
            if (langCode === 'EN')
                dataJson = require('./../transalations/components/visualStepperComponent/visualStepperComponent_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/components/visualStepperComponent/visualStepperComponent_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/components/visualStepperComponent/visualStepperComponent_RU.json')
            else
                dataJson = require('./../transalations/components/visualStepperComponent/visualStepperComponent_HE.json')
            break;
        case 'chargingAction':
            if (langCode === 'EN')
                dataJson = require('./../transalations/components/chargingAction/chargingAction_EN.json')
            else if (langCode === 'AE')
                dataJson = require('./../transalations/components/chargingAction/chargingAction_AE.json')
            else if (langCode === 'RU')
                dataJson = require('./../transalations/components/chargingAction/chargingAction_RU.json')
            else
                dataJson = require('./../transalations/components/chargingAction/chargingAction_HE.json');
            break;
        default:
            dataJson = {};
            break;
    }

    const margedData = {
        ...dataJson,
        general: generalJson,
        accessibility: accessibilityJson
    }

    return margedData;
}

export default translationService;
